module.exports = __webpack_public_path__ + "static/media/default-hub.ab15e2cc.svg";